import { createRouter, createWebHashHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import MoreView from '../views/AditionalView.vue'
import Login from '../views/LoginView.vue'
import Register from '../views/RegistartionView.vue'
import Personal from '../views/PersonalView.vue'
import Publish from '../views/PublicationView.vue'
import Admin from '../views/AdminView.vue'
import Archive from '../views/ArchiveView.vue'
//import store from '@/store/index'

const routes = [{
        path: '/',
        name: 'home',
        component: HomeView
    },
    {
        path: '/more',
        name: 'more',
        component: MoreView
    },
    {
        path: '/login',
        name: 'login',
        component: Login
    },
    {
        path: '/register',
        name: 'register',
        component: Register
    },
    {
        path: '/personal',
        name: 'personal',
        component: Personal
    },
    {
        path: '/adminconfs',
        name: 'adminconfs',
        component: Admin
    },
    {
        path: '/publish',
        name: 'publish',
        component: Publish
    },
    {
        path: '/archive',
        name: 'archive',
        component: Archive,
        //props: route => ({ query: route.query.year })
    },
    {
        path: "/:catchAll(.*)",
        name: '404',
        component: HomeView

    }
]

const router = createRouter({
    history: createWebHashHistory(),
    routes,

})
router.beforeEach((to, from, next) => {
    const access_token = localStorage.getItem('access_token')
    if (access_token != null) {
        var valid = access_token.length > 200 ? true : false
    }

    // Block personal
    if ((to.name === 'personal') || (to.name == 'publish') || (to.name == 'adminconfs')) {
        if ((!access_token) || !valid) {
            return next({ name: 'login' })
        }
    }

    //if (to.name == 'adminconfs') {
    //    if ((!access_token) || !valid) {
    //        return next({ name: 'login' })
    //    } else {
    //        if (store.getters.User.role != "0") {
    //            return next({ name: 'home' })
    //        }
    //    }
    //}

    next()
})

export default router